import React, { useState, useRef, useMemo, useCallback } from "react";
import SearchIcon from "../../icons/searchIcon";
import CloseIcon from "../../icons/closeIcon";
import styles from "./style.module.css";

const SearchFilter = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  const handleSearch = useCallback((query) => {
    setSearchQuery(query);
    onSearch(query);
  }, [onSearch]);

  const debouncedSearch = useMemo(() => {
    const delay = 500;
    let timeoutId;
    return (value) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => handleSearch(value), delay);
    };
  }, [handleSearch]);

  return (
    <div className={styles.search_filter}>
      <input
        type="text"
        placeholder="Search"
        ref={searchInputRef}
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          debouncedSearch(e.target.value);
        }}
      />
      <SearchIcon className={styles.search_icon} />
      {searchQuery && (
        <span className={styles.close_icon} onClick={() => handleSearch("")}>
          <CloseIcon />
        </span>
      )}
    </div>
  );
};

export default SearchFilter;
